// extracted by mini-css-extract-plugin
module.exports = {"page":"_2s5TN","left-column":"A5IZd","leftColumn":"A5IZd","fadein":"O4762","slideUp":"ildZL"};